/**
 * Custom modal trigger element
 */
export var ModalMarkup;
(function (ModalMarkup) {
    ModalMarkup["H1"] = "h1";
    ModalMarkup["H2"] = "h2";
    ModalMarkup["H3"] = "h3";
    ModalMarkup["H4"] = "h4";
    ModalMarkup["H5"] = "h5";
    ModalMarkup["H6"] = "h6";
    ModalMarkup["P"] = "p";
    ModalMarkup["SPAN"] = "span";
    ModalMarkup["DIV"] = "div";
    ModalMarkup["BUTTON"] = "button";
    ModalMarkup["A"] = "a";
})(ModalMarkup || (ModalMarkup = {}));
export var ModalCtaMarkup;
(function (ModalCtaMarkup) {
    ModalCtaMarkup["BUTTON"] = "button";
    ModalCtaMarkup["DIV"] = "div";
    ModalCtaMarkup["A"] = "a";
})(ModalCtaMarkup || (ModalCtaMarkup = {}));
//# sourceMappingURL=ModalEnum.js.map